module.exports = __webpack_public_path__ + "static/media/evil-bot.42cc3bd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/evil-bot.svg
// module id = 39
// module chunks = 0